<template>
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启报销">
        <div>
          <el-radio-group v-model="form.status">
            <el-radio  :label="1">开启</el-radio>
           <el-radio  :label="0">关闭</el-radio>
          </el-radio-group>
         
        </div>
      </el-form-item>

      <el-form-item label="最低报销数量">
        <div>
          <el-input v-model="form.min_expenses_num"></el-input>
        
         
        </div>
      </el-form-item>

      <el-form-item label="是否开启倍数报销">
        <div>
          <el-radio-group v-model="form.is_multiple">
            <el-radio  :label="1">开启</el-radio>
           <el-radio  :label="0">关闭</el-radio>
          </el-radio-group>
         
        </div>
      </el-form-item>

      <!-- 指定一个报销人 -->
      <!-- <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">指定审核人</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
          </div>
        </el-row>
        <div>
          对于移动端，审核人是直属上级/移交上级，后台则可直接设置最高等级的代理进行审核
        </div>
      </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

     <!--添加-->
     <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>
  </div>
</template>

<script>
import ExpensesApi from '@/api/expenses.js';

import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      /*编辑组件*/
      GetUser
    },
  data() {
    return {
      /*form表单数据*/
      form: {
        status: 0,
        user_id:"",
        min_expenses_num:0,
        is_multiple:0,//1 开启 0 关闭
      },
      user_info: {},
      /*是否正在加载*/
      loading: false,
      open_add:false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
       /*打开弹出层*/
       addClick() {
        this.open_add = true;
      },
      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },

    /*获取数据*/
    getData() {
      let self = this;
      ExpensesApi.getSetting({}, true)
        .then(data => {
          if(data.data != null){
            self.form = data.data;
            if(self.form.user){
              this.user_info = self.form.user;
            }
          }
        
          self.loading=false;
        })
        .catch(error => {});
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      console.log(params)
      if(params.status == ""){
        params.status = 0;
      }
      ExpensesApi.setting(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/expenses/setting.vue